import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeUtilService } from '../util/date-time-util.service';

@Pipe({
  name: 'localDateTime'
})
export class LocalDateTimePipe implements PipeTransform {

  constructor(private dateTimeUtilService: DateTimeUtilService) {
  }

  transform(dateTime?: string, format?: string): string {
    if (!dateTime) {
      return '';
    }

    return this.dateTimeUtilService.formatDateTimeToLocal(dateTime, format);
  }
}
